














import Vue from 'vue'
import SocialPageLinks from '@/components/SocialPageLinks.vue'

export default Vue.extend({
  components: { SocialPageLinks },
})
